import './frontend.scss'
import React, { useState, useEffect, useRef } from "react"
import ReactDOM from "react-dom"
import axios from 'axios';
import { TicketingData } from './components/uploadRep'
import LayoutReview from './components/layoutReview';

  const link = document.createElement('link');

  link.rel = 'stylesheet';
  link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/css/all.min.css';

  document.head.appendChild(link);
  const divsToUpdate = document.querySelectorAll<HTMLDivElement>('.users-profile-plugin')

divsToUpdate.forEach(div => {
  const preElement = div.querySelector<HTMLPreElement>('pre');
  if (preElement) {
    ReactDOM.render(<Users />, div);
    div.classList.remove('users-profile-plugin');
  } else {
    console.error('Could not find the <pre> element');
  }
});

  interface CurrentUser  {
    ID: number,
    user_login: string,
    display_name: string,   
    roles: string[],
    nonce: string
    last_name: string;
  }
interface Contacts {
  ID?: string;
  Name?: string;
}

interface User  {
  ID: number;
  user_login: string;
  display_name: string;
  roles: string[];
  first_name: string
  email: string;
  cin7UserId: string;
  cin7ContactId: string;
 cin7BrandsAllowed: string[];
cin7ApiDiff: string;
company: string;
last_name: string;
Contacts?: Contacts[]
layoutPermission?: string;
};

declare global {
  interface Window {
    UsersData?: {
      users: User[];
     currentUser: CurrentUser
     brands: string;
     brands_approval?: string
    };
  }
}

export default function Users() {
  // working set as 1
  const [page, setPage] = useState(1)
  const [wpUserData, setWpUserData] = useState<User[]>([]);
  const [currentUser, setCurrentUser] = useState<CurrentUser | null>(null);
  const [filter, setFilter] = useState('');
const [brands, setBrands] = useState<string[]>([]);
const [successMap, setSuccessMap] = useState<Record<number, boolean>>({});
const [failMap, setFailMap] = useState<Record<number, boolean>>({});
const [loadingMap, setLoadingMap] = useState<Record<number, boolean>>({});
const [errorMap, setErrorMap] = useState<Record<number, string>>({});
const [lookupLoadingMap, setLookupLoadingMap] = useState<Record<number, boolean>>({});



  useEffect(() => {
    if (window.UsersData) {
      setWpUserData(window.UsersData.users);
      setCurrentUser(window.UsersData.currentUser);
    setBrands(window.UsersData.brands.split(',').map(b => b.trim())); 
    }
  }, []);



  

  const filteredUsers = wpUserData.filter(user => {
  const search = filter.toLowerCase();
  const fullName = `${user.first_name || ''} ${user.last_name || ''}`.toLowerCase();

  return (
    user.user_login?.toLowerCase().includes(search) ||
    fullName?.toLowerCase().includes(search) ||
    user.email?.toLowerCase().includes(search) ||
    user.company?.toLowerCase().includes(search) 
  );
});

useEffect(() => { console.log('userdata', wpUserData, 'current user', currentUser)},[wpUserData, currentUser])

    const fetchCustomerInfo = async (location: string, user_id: number, customerId: string) => {
    if (lookupLoadingMap[user_id]) return;
    const payload = {
      customerId,
    };
    try {
      if (!location) {
        throw new Error('Please Select Country');
      }
      if (!customerId) {
        throw new Error('No Cin7 user ID set');
      }
      setLookupLoadingMap(prev => ({ ...prev, [user_id]: true }));
      setErrorMap(prev => { const { [user_id]: _, ...rest } = prev; return rest; });
      const res = await axios.post(
        window.tagabelData.root_url + '/wp-json/submit/v1-user-two/data',
        payload,
        {  headers: { 'x-custom-header': 'x-auth-token',
           'X-WP-Nonce': window.tagabelData?.nonce,
           'location': location
         }}
      );

      if (res.data?.status && res.data.status >= 400) {
        console.log('error res.data', res.data, 'body type:', typeof res.data.body);
        let body = res.data.body;
        if (typeof body === 'string') {
          try { body = JSON.parse(body); } catch {}
        }
        throw new Error(body?.[0]?.Exception || res.data.message || 'Request failed');
      }

      const customer = res.data?.CustomerList?.[0];
      if (!customer) {
        throw new Error('No customer found');
      }

      const contactId = customer.Contacts ?? [];
      if (contactId.length === 0) {
        throw new Error('No contacts found for this customer');
      }

      handleContacts(user_id, contactId)

//  handleCin7Change(user_id, contactId, 'cin7ContactId')
    } catch (error: any) {
      console.error('Failed to fetch customer info:', error);
      const data = error?.response?.data;
      let body = data?.body;
      if (typeof body === 'string') {
        try { body = JSON.parse(body); } catch {}
      }
      const message =
        body?.[0]?.Exception ||
        data?.message ||
        (error instanceof Error ? error.message : 'Something went wrong');
      setErrorMap(prev => ({ ...prev, [user_id]: message }));
    } finally {
      setLookupLoadingMap(prev => { const { [user_id]: _, ...rest } = prev; return rest; });
    }
  };

  const handleContacts = (id: number, contacts: Contacts[]) => {
  setWpUserData(prev =>
    prev.map(user =>
      user.ID === id ? { ...user, Contacts: contacts } : user
    )
  );
};



const handleSubmit = async (user: User) => {

  if (loadingMap[user.ID]) return;


  setLoadingMap(prev => ({ ...prev, [user.ID]: true }));

  try {
    const res = await axios.post(
      window.tagabelData.root_url + '/wp-json/custom/v1/user-meta',
      { user_id: user.ID,
         cin7UserId: user.cin7UserId,
         company: user.company,
         cin7BrandsAllowed: user.cin7BrandsAllowed,
         cin7ApiDiff: user.cin7ApiDiff,
         cin7ContactId: user.cin7ContactId,
         layoutPermission: user.layoutPermission
         
        
        },
     { headers: { 'X-WP-Nonce': currentUser?.nonce || '' } } // include nonce

    );

    setSuccessMap(prev => ({ ...prev, [user.ID]: true }));

    setTimeout(() => {
      setSuccessMap(prev => ({ ...prev, [user.ID]: false }));
      setLoadingMap(prev => ({ ...prev, [user.ID]: false }));
    }, 3000);
  } catch (err: any) {
    console.error('Error:', err.response?.data || err);

    const message = err.response?.data?.message || 'Please fill out all fields';

    // Mark failure
    setFailMap(prev => ({ ...prev, [user.ID]: true }));
    setErrorMap(prev => ({ ...prev, [user.ID]: message }));

    // Clear loading after fail
    setTimeout(() => {
      setFailMap(prev => ({ ...prev, [user.ID]: false }));
      setErrorMap(prev => ({ ...prev, [user.ID]: '' }));
      setLoadingMap(prev => ({ ...prev, [user.ID]: false }));
    }, 3000);
  }
};

const handleChange = (id: number, value: string, userKey: keyof User) => {
  setWpUserData(prev =>
    prev.map(user =>
      user.ID === id ? { ...user, [userKey]: value } : user
    )
  );
};

const handleBrandToggle = (userID: number, brand: string) => {
  setWpUserData(prev =>
    prev.map(user => {
      if (user.ID !== userID) return user;

      const allowedSet = new Set(user.cin7BrandsAllowed || []);

      if (allowedSet.has(brand)) {
        allowedSet.delete(brand);
      } else {
        allowedSet.add(brand);
      }

      const cleaned = Array.from(allowedSet).filter(b =>
        brands.includes(b)
      );

      return {
        ...user,
        cin7BrandsAllowed: cleaned,
      };
    })
  );
};





const country = ['China', 'Singapore']
const [debouncedCin7Id, setDebouncedCin7Id] = useState<string | null>(null);

const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

const handleCin7Change = (userId: number, value: string,  userKey: keyof User) => {
  handleChange(userId, value, userKey); // keep your existing logic

  if (timeoutRef.current) {
    clearTimeout(timeoutRef.current);
  }

  timeoutRef.current = setTimeout(() => {
    setDebouncedCin7Id(value);
  }, 2000);
};


useEffect(() => {
  if (!debouncedCin7Id) return;

console.log('ran api')

}, [debouncedCin7Id]);
  // jsx
    return (
<>
<div className='flex justify-center items-center gap-3 pt-5'>
  <button
    onClick={() => setPage(1)}
    className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors border ${
      page === 1
        ? 'bg-blue-600 text-white border-blue-600 hover:bg-blue-700'
        : 'bg-white text-blue-600 border-blue-600 hover:bg-blue-50'
    }`}
  >
    Update Users
  </button>
  <button
    onClick={() => setPage(2)}
    className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors border ${
      page === 2
        ? 'bg-blue-600 text-white border-blue-600 hover:bg-blue-700'
        : 'bg-white text-blue-600 border-blue-600 hover:bg-blue-50'
    }`}
  >
    Layout Reviews
  </button>
</div>
{page === 1 && (
<>
    <TicketingData isExpanded={false}/>
<div className='user-form-wrapper'>

      <h2 className='text-2xl font-bold'>Users</h2>
      <div className='pt-5 pb-6'>

      <p className='pb-5'>Filter Users by name, email, company or user name</p>
      <input type="text" className='users-input'  onChange={e => setFilter(e.target.value)} />

      </div>
        
      {filteredUsers.map((user, userIdx) => (
        <div key={user.ID} className='users-card'>
          <div className="users-info-section">

          </div>



          
          <div className='flex flex-col justify-start items-start'>
          <p className='pb-5' >Client Name: {user.display_name || `${user.first_name} ${user.last_name}`}</p>      
          <p className='pb-5' >User Name: {user.user_login}</p>      
          <p className='pb-5' >User Email: {user.email}</p> 
<div className="pt-5">
<p className='pb-3 text-sm text-blue-600'>Cin7 Customer ID</p>
          <input
          className='users-input'
          type="text"
          value={user.cin7UserId || ''}
          onChange={e => handleCin7Change(user.ID, e.target.value, 'cin7UserId')}
          />
          </div>
          
          <div className="pt-5">
  <p className="pb-3 text-sm text-blue-600">Country for cin7 API</p>
  <div className="flex flex-wrap gap-2">
    {country.map(c => (
      <label key={c} className="flex items-center gap-1">
        <input
          type="radio"
            value={c}
          name={`cin7ApiDiff-${user.ID}`} 
          checked={user.cin7ApiDiff === c}    
          onChange={(e) => handleChange(user.ID, e.target.value, 'cin7ApiDiff')}
        />
        {c}
      </label>
    ))}
  </div>
</div>


<div className="pt-5" 
onClick={() => fetchCustomerInfo(user.cin7ApiDiff, user.ID, user.cin7UserId)}>
<p className={`p-3 bg-blue-300 rounded-2xl ${lookupLoadingMap[user.ID] ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}>{lookupLoadingMap[user.ID] ? 'Loading...' : 'Lookup Contacts'}</p>
{errorMap[user.ID] && <p className='text-red-500'>{errorMap[user.ID]}</p>}

</div>

<div className="pt-5">{user.Contacts && user.Contacts.length > 0 && (
  <select
    className='users-input mt-3'
    value={user.cin7ContactId || ''}
    onChange={e => handleCin7Change(user.ID, e.target.value, 'cin7ContactId')}
  >
    <option value=''>Select a contact</option>
    {user.Contacts.map(contact => (
      <option key={contact.ID} value={contact.ID}>{contact.Name}</option>
    ))}
  </select>
)}</div>



<div className="pt-5">
<p className='pb-3 text-sm text-blue-600'>Cin7 contact ID</p>
          <input
          className='users-input'
          type="text"
          value={user.cin7ContactId || ''}
          onChange={e => handleCin7Change(user.ID, e.target.value, 'cin7ContactId')}
          />
          </div>

          <div className="pt-5">
  <p className="pb-3 text-sm text-blue-600">Layout Permission</p>
  <div className="flex flex-wrap gap-2">
  
      <label className="flex items-center gap-1">
        <input
          type="radio"
            value={'yes'}
          name={`layoutPermission-${user.ID}`} 
          checked={user.layoutPermission === 'yes'}    
          onChange={(e) => handleChange(user.ID, e.target.value, 'layoutPermission')}
        />
      Yes
      </label>

          <label className="flex items-center gap-1">
        <input
          type="radio"
            value={'no'}
          name={`layoutPermission-${user.ID}`} 
          checked={user.layoutPermission === 'no'}    
          onChange={(e) => handleChange(user.ID, e.target.value, 'layoutPermission')}
        />
      No
      </label>
  
  
  </div>
</div>

<div className="pt-5">
<p className='pb-3 text-sm text-blue-600'>Company</p>
          <input
          className='users-input'
          type="text"
          value={user.company || ''}
          onChange={e => handleChange(user.ID, e.target.value, 'company')}
          />
          </div>


<div className="pt-5">
  <p className="pb-3 text-sm text-blue-600">Brands Allowed</p>
  <div className="flex flex-wrap gap-2">
    {brands.map(brand => (
      <label key={brand} className="flex items-center gap-1">
        <input
          type="checkbox"
          checked={user.cin7BrandsAllowed?.includes(brand) || false}
          onChange={() => handleBrandToggle(user.ID, brand)
            
          }
        />
        {brand}
      </label>
    ))}
  </div>
</div>









          <div className='pt-5'>
               {(!successMap[user.ID] && !failMap[user.ID]) && (
            <button className='save-button' onClick={(e) => handleSubmit(user)} type="submit">Update Info</button>
               )}
                {successMap[user.ID] && (
        <button className='success-button'>Info Saved!</button>
      )}
          {failMap[user.ID] && (<>
        <button className='fail-button'>Save failed</button>
        <p>{errorMap[user.ID]}</p>
          </>
      )}
          </div>
            </div>
       
        </div>
      ))}
    
</div>
</>
)}

{ page === 2 && (
<LayoutReview/>
)}
</>
  );
}
  